import { useData } from "./DataContext.js";

export default function CharPicture (props)
{
    const gData = useData();

    const width = props.width === undefined ? "auto" : props.width;
    const height = props.height === undefined ? "auto" : props.height;
    const margin = props.margin === undefined ? "none" : props.margin;

    let charContent = gData.content.chars[props.charId];
    if (props.charId === null)
    {
	charContent = {
	    id: "inconnu",
	    firstName: "personnage inconnu",
	};
    }
    
    let src = gData.gameId + "/pictures/chars/" + charContent.id + (props.thumbnail ? "-thumbnail" : "") + ".png";
    if (charContent.picture !== undefined) src = gData.gameId + "/pictures/chars/" + charContent.picture;
    const alt = "Image de " + charContent.firstName + " " + charContent.lastName;
    
    return (<img src={src} alt={alt} style={{ width, height, margin }}/>);
}
